import { useRef, useCallback } from "react";

function useDebounce(fn, delay = 500) {
    const timer = useRef(null);

    return useCallback(
        (...args) => {
            if (timer.current) {
                clearTimeout(timer.current);
            }

            timer.current = setTimeout(() => {
                fn(...args);
            }, delay);
        },
        [fn, delay]
    );
}

export default useDebounce;
